import { render, staticRenderFns } from "./BookmarkDialog.vue?vue&type=template&id=420481fe"
import script from "./BookmarkDialog.vue?vue&type=script&lang=js"
export * from "./BookmarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports